import axios from "axios";


const api = axios.create({
  baseURL: "https://server.cais.edu.kh/api/",
  withCredentials: true,
});

// Attach token to every request
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("access_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle expired tokens (401 Unauthorized)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Prevent infinite loop
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        const refresh = sessionStorage.getItem("refresh_token");
        if (refresh) {
          const res = await axios.post("https://server.cais.edu.kh/api/token/refresh/", {
            refresh,
          });

          // Save new tokens
          sessionStorage.setItem("access_token", res.data.access);
          if (res.data.refresh) {
            sessionStorage.setItem("refresh_token", res.data.refresh);
          }

          // Update header and retry request
          api.defaults.headers.common["Authorization"] =
            "Bearer " + res.data.access;
          originalRequest.headers["Authorization"] = "Bearer " + res.data.access;

          return api(originalRequest);
        }
      } catch (err) {
        console.error("Token refresh failed:", err);
        sessionStorage.clear();
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
